export const routePermissionsMap = {
    '/role': {
        GET: 'role_manage',
        POST: 'role_manage',
        PUT: 'role_manage',
        DELETE: 'role_manage',
    },
    '/permission': {
        GET: 'role_manage',
        POST: 'role_manage',
        PUT: 'role_manage',
        DELETE: 'role_manage',
    },
    '/labour': {
        GET: 'labour_view',
        PUT: 'labour_edit',
        PATCH: 'update_profile',
    },
    '/labour/verify': {
        PUT: 'labour_verification',
    },
    '/labour/availability': {
        PATCH: 'update_profile',
    },
    '/user': {
        POST: 'user_create',
        GET: 'user_view',
        PUT: 'user_edit',
        DELETE: 'user_delete',
    },
    '/user/changeStatus': {
        PATCH: 'user_activate',
    },
    '/user/grant': {
        POST: 'role_manage',
    },
    '/user/revoke': {
        POST: 'role_manage',
    },
    '/user/restrict': {
        POST: 'role_manage',
    },
    '/user/permissions': {
        GET: 'role_manage',
    },

    '/availability/calendar': {
        GET: 'availability_view_calander'
    },
    '/availability': {
        POST: 'availability_create',
        GET: 'availability_view',
        PUT: 'availability_update',
        DELETE: 'availability_delete',
    },
    '/allocation-request': {
        POST: 'allocation_request_create',
        GET: 'allocation_request_view',
        DELETE: 'allocation_request_delete',
    },
    '/allocation-request/{id}': {
        PUT: 'allocation_request_edit',
    },
    '/allocation-request/{id}/respond': {
        PUT: 'allocation_request_respond',
    },
    '/allocation-request/history': {
        GET: 'allocation_request_view',
    },
    '/job': {
        POST: 'job_create',
        GET: 'job_view',
    },
    '/job/{id}': {
        GET: 'job_view',
        PUT: 'job_edit',
        DELETE: 'job_delete',
    },
    '/job/{id}/close': {
        PUT: 'job_close',
    },
    "/rating": {
        POST: "rating_create",
        GET: "rating_view",
        PUT: "rating_update"
    },
    "/rating/{id}": {
        GET: "rating_view"
    },
    '/chat': {
        POST: 'chat_manage',
        GET: 'chat_manage',
    },
    '/chat/:chatId': {
        GET: 'chat_manage',
    },
    '/chat/detail/:chatId': {
        GET: 'chat_manage',
    },
    '/chat/message/:messageId/read': {
        POST: 'chat_manage',
    },
};